// ═══════════════════════════════════════════════════════════════════
//  LiveCallPopup — small floating notification that appears in the
//  bottom-right when an inbound VoIP call is detected (within last
//  30 seconds). Polls every 5s. Shows patient info if matched, or a
//  "Register" CTA if it's an unknown number.
// ═══════════════════════════════════════════════════════════════════

import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Phone, X, UserPlus } from 'lucide-react';

export default function LiveCallPopup({ API_BASE, onSelectPatient, onRegisterUnknown }) {
  const [call, setCall] = useState(null);
  const [dismissed, setDismissed] = useState(null);   // call _id we hid
  const timer = useRef(null);

  useEffect(() => {
    const tick = async () => {
      try {
        const r = await axios.get(`${API_BASE}/voip/live`);
        if (r.data && r.data._id !== dismissed) setCall(r.data);
        else if (!r.data) setCall(null);
      } catch {}
    };
    tick();
    timer.current = setInterval(tick, 5000);
    return () => clearInterval(timer.current);
  }, [API_BASE, dismissed]);

  if (!call) return null;
  const patient = call.patientId;

  return (
    <div style={popup}>
      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
        <div style={ring}><Phone size={18} color="#fff"/></div>
        <div style={{ flex:1, minWidth:0 }}>
          <div style={{ fontSize:11, color:'#10b981', fontWeight:800, textTransform:'uppercase', letterSpacing:0.5 }}>📞 Incoming Call</div>
          <div style={{ fontSize:15, fontWeight:700, color:'#0f172a', marginTop:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {patient ? patient.name : 'Unknown caller'}
          </div>
          <div style={{ fontSize:12, color:'#6b7785' }}>
            {call.fromNumber} {patient?.uhid && `· ${patient.uhid}`}
          </div>
        </div>
        <button onClick={()=>{ setDismissed(call._id); setCall(null); }} style={btnX}><X size={16}/></button>
      </div>
      <div style={{ display:'flex', gap:8, marginTop:10 }}>
        {patient ? (
          <button onClick={()=>{ onSelectPatient && onSelectPatient(patient); setDismissed(call._id); setCall(null); }} style={btnPrimary}>
            Open Profile
          </button>
        ) : (
          <button onClick={()=>{ onRegisterUnknown && onRegisterUnknown(call.fromNumber); setDismissed(call._id); setCall(null); }} style={btnPrimary}>
            <UserPlus size={13}/> Register Patient
          </button>
        )}
      </div>
    </div>
  );
}

const popup = {
  position:'fixed', bottom:20, right:20, zIndex:9999,
  background:'#fff', borderRadius:14, padding:14,
  boxShadow:'0 10px 30px rgba(15,23,42,0.18)', border:'1px solid #e5e9f0',
  width: 320, animation: 'oralzy-slide 0.25s ease',
};
const ring = {
  width:36, height:36, borderRadius:18, background:'#10b981',
  display:'flex', alignItems:'center', justifyContent:'center',
  animation:'oralzy-pulse 1.4s ease-in-out infinite',
};
const btnX = { background:'transparent', border:'none', cursor:'pointer', color:'#9aa5b1', padding:4 };
const btnPrimary = {
  display:'inline-flex', alignItems:'center', gap:6, justifyContent:'center',
  padding:'8px 14px', borderRadius:8, border:'none', cursor:'pointer',
  background:'#F57C1F', color:'#fff', fontWeight:700, fontSize:13, flex:1,
};
